<template>
  <div class="page-about">

    <header-prop class="header-prop-about" title="Essential" subtitle="ingredients">
      <a href="https://vuejs.org" target="_blank">
        <img src="../assets/icon-vue.svg" width=100 />
      </a>
      <a href="https://octobercms.com/" target="_blank">
        <img class="october" src="../assets/icon-october.svg" width=70 />
      </a>
      <a href="https://developer.apple.com/ios/" target="_blank">
        <img src="../assets/icon-ios.svg" width=100 />
      </a><br />
      <a href="https://developer.android.com/studio/index.html" target="_blank">
        <img src="../assets/icon-android.svg" width=100 />
      </a>
      <a href="https://facebook.github.io/react-native/" target="_blank">
        <img src="../assets/icon-react.svg" width=100 />
      </a>
      <a href="https://firebase.google.com/" target="_blank">
        <img class="grayscale" src="../assets/icon-firebase.svg" width=100 />
      </a>
    </header-prop>

    <content-project-list-section></content-project-list-section>

    <div class="particle-wrapper">
      <vue-particles color="#A01A37" :particleOpacity="5" :particlesNumber="15" shapeType="edge" :particleSize="8.5" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :moveDirection="'bottom'" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" class="particle-main">
      </vue-particles>

      <div class="hero section-about" id="section-about">
        <div class="hero-body">
          <div class="container">
            <div class="columns is-gapless is-centered is-multiline">
              <div class="column is-10 is-content has-text-left" data-aos="fade-in" data-aos-once="true">
                <p>
                  <h3 class="text-faded has-text-centered">
                    <br />
                    <br />
                    hello, we are <span class="color-orange">passionate</span> <span class="color-gray">\\n</span>
                    <br /><span>
                      <b>
                        <a href="/contact" target="_blank">
                        <u style="border-bottom:1px solid #fc0;text-decoration:none;color:white;">coders</u></a> &amp;
                        <a href="/contact" target="_blank"><u style="border-bottom:1px solid #A01A37;text-decoration:none;color:white;">designers</u></a>
                      </b>
                    </span>,
                    <!--<br />with over <span class="color-orange">9 years</span> of experience.-->
                    <br />specializing <span class="color-red">minimal</span> UI / UX design.
                    <br />tayloring <span class="color-gray">bespoke</span> software solutions.
                    <br />
                    <div style="display:inline-block;margin-left:auto;margin-right:auto;" ng-cloak>
                      <span class="typewriter-start typewriter">
                        <div style="border-width:3px;">
                          <span style="color:#F0A202;">&gt;:</span>&nbsp;&nbsp;
                        </div>
                      </span>
                    </div>
                    <br />
                  </h3>
                </p>
                <br />
                <a href="#" class="button is-medium" @click="$event.preventDefault();$scrollTo('#carousel-slick', { offset: -30 })" style="cursor:pointer;" v-if="false">Run</a>
                <br />
                <br />
              </div>
              <div class="column is-4 is-card has-text-left" style="overflow:hidden;" v-if="false">
                <!-- block item markup
                <img :src="image.image_900" class="img-responsive" style="width:100%;" /> -->
                <div class="card" data-aos="fade-left" data-aos-once="true">
                  <div class="card-image">
                    <figure class="image">
                      <img src="../assets/logo.svg" width="150" alt="Image" style="width:300px;margin:0 auto;">
                    </figure>
                  </div>
                  <div class="card-content" style="background-color:lightgray;">
                    <div class="media">
                      <div class="media-left">
                        <figure class="image is-48x48">
                          <img src="http://via.placeholder.com/96/ffffff/000000" alt="Image" style="border-radius:30px;">
                        </figure>
                      </div>
                      <div class="media-content">
                        <p class="title is-4">noctorus</p>
                        <p class="subtitle is-6"><span class="color-orange">&gt;:</span> <span class="color-gray">= nocturnal</span></p>
                      </div>
                    </div>

                    <div class="content">
                      Bzzz.<br />
                      <a>#metaphorical</a> <a>#concepts</a>
                      <br>
                      <small>{{ '11:09 PM - 1 Jan 2017' }}</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <carousel-slick></carousel-slick>

    <div style="position:relative;z-index:1;">
      <a class="next-section next-blue" rel="nofollow" href="#portfolio" @click="$event.preventDefault();$scrollTo('#section-services', { offset: 0 })">
        <!-- inspired from: http://www.vtcreative.fr/en/ -->
        <i class="material-icons" style="font-size:1.5em;">keyboard_arrow_down</i>
      </a>
    </div>

    <div class="section-services" id="section-services">
      <section style="position:relative;width:100%;">

        <div id="services-bg">
            &nbsp;
        </div>

        <div id="services-cover">
            &nbsp;
        </div>

        <div class="container" style="padding-top:50px;">
          <div class="columns is-gapless">
            <div class="column has-text-centered">
              <h2 class="title">core</h2>
              <hr class="center">
            </div>
          </div>
        </div>

        <div class="container">
          <div class="columns is-centered is-gapless">
            <div class="column is-2 has-text-centered" data-aos="fade-up" data-aos-once="true">
              <i class="fa fa-4x fa-circle-o color-orange" data-sr="wait 0.0s, move 0px scale up 20%, over 0.6s" style="padding:15px;margin-top:30px;"></i>
              <h3>minimal</h3>
            </div>
            <div class="column is-2 has-text-centered" data-aos="fade-up" data-aos-once="true">
              <i class="fa fa-4x fa-hand-spock-o color-blue" data-sr="wait 0.0s, move 0px scale up 20%, over 0.6s" style="padding:15px;margin-top:30px;"></i>
              <h3>passionate</h3>
            </div>
            <div class="column is-2 has-text-centered" data-aos="fade-up" data-aos-once="true">
              <i class="fa fa-4x fa-cube color-red" data-sr="wait 0.0s, move 0px scale up 20%, over 0.6s" style="padding:15px;margin-top:30px;"></i>
              <h3>extensible</h3>
            </div>
          </div>
        </div>

        <div class="container" style="margin-top:80px;margin-bottom:0px;" v-if="false">
          <div class="columns is-gapless">
            <div class="column has-text-centered">
              <i class="fa fa-4x fa-gear" style="color:#bbb;"></i>
            </div>
          </div>
        </div>

        <div class="container" v-if="false">
          <div class="columns is-gapless">
            <div class="column has-text-centered">
              <h2 class="title">stack</h2>
              <hr class="center">
            </div>
          </div>
        </div>

        <div class="container" style="margin-top:50px;padding-bottom:50px;">
          <div class="columns is-centered is-gapless">

            <div class="column is-4 has-text-centered" data-aos="fade-up" data-aos-once="true">
              <i class="fa fa-4x fa-cubes color-gray" data-sr="wait 0.0s, move 0px scale up 20%, over 0.6s" style="padding:15px;"></i>
              <h3>engine</h3>
            </div>
          </div>

          <div class="columns is-centered is-gapless" data-aos="fade-right" data-aos-once="true">
            <div class="column is-3 is-6-tablet is-3-desktop has-text-left" style="padding:30px;padding-top:0;">
              <br />
              <div class="content">
                <ul>
                  <li>Brand / corporate identity</li>
                  <li>Collateral design</li>
                  <li>UI / UX design</li>
                  <li>App development</li>
                  <li>Web solutions</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>

    <section-comment v-if="false"></section-comment>

  </div>
</template>

<script>
  import VueParticles from '@/components/Particles'

  import HeaderProp from '@/components/HeaderProp'
  import CarouselSlick from '@/components/CarouselSlick'
  import ContentProjectListSection from '@/components/ContentProjectListSection'
  import ContactSection from '@/components/ContactSection'

  export default {
    name: 'about',
    metaInfo: {
      title: 'about'
    },
    components: {
      VueParticles,
      HeaderProp,
      CarouselSlick,
      ContactSection,
      ContentProjectListSection
    },
    data () {
      return {
        scrollPos: 0
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.header-prop-about {
  img {
    transition: all 0.2s ease-in-out 0s;
    width: 100px;
    padding: 5px;

    &.october {
      width: 70px;
      margin-bottom: 10px;
    }

    &.grayscale {
      filter: gray; /* IE6-9 */
      -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
      filter: grayscale(1); /* Microsoft Edge and Firefox 35+ */
    }

    &:hover {
      -webkit-filter: brightness(40%);
      filter:brightness(40%);
    }
  }
}

.particle-wrapper {
   position: relative;
   width: 100%;
   height: 100%;
   overflow: hidden;

   .particle-main {
     position: absolute;
     width: 100%;
     height: 100%;

     canvas {
       min-height: 200vh;
     }
   }
}

.page-about {

  .text-faded {
    // color: rgba(255, 255, 255, .7);
    color: $color-white-transparent;
  }

  a {
    color: $color-black;
  }

  h1, h2, h3, h4, h5, h6 {
    letter-spacing: .02em;
  }

  .is-content, .is-card {
    padding: 25px;

    @media screen and (min-width: $tablet) {
      padding: 0;
    }
  }

  .card {
    border-radius: 5px;
    overflow: hidden;
    width: 300px;

    @media screen and (min-width: $desktop) {
      width: 100%;
      max-width: 350px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}

@media screen and (min-width: $tablet) and (max-width: ($desktop - 1)) {
  .page-about {
    .is-card {
      width: 300px;
    }
  }
}

#section-about {
  background-color: $color-blue;
  // background-image: linear-gradient(#283044 25%, #182034 75%);
  font-size: 1.2em;
  line-height: 2em;
}

.next-blue {
  background-color: gray;
  color: $color-gray;
}

#section-services {
  background-position: 0% 20%;
  background-repeat: no-repeat;
  background-image: url(../assets/pattern02_righthalf.png);
  background-size: inherit;
}

#services-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: transparent;

  @media screen and (max-width: $mobile) {
    background-color: rgba(255, 255, 255, 0.8);
  }
}

</style>



// WEBPACK FOOTER //
// About.vue?37068198